import React, {Component} from 'react';
import {BrowserRouter} from 'react-router-dom';
import './Index.css';
import ParallaxLayout from "../../components/layout/ParallaxLayout";
import ScrollToTop from '../../containers/ScrollToTop';

/**
 * Index View
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class Index extends Component {

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        return (
            <BrowserRouter>
                <ScrollToTop>
                    <ParallaxLayout/>
                </ScrollToTop>
            </BrowserRouter>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/index/Index.jsx